import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs';
import { UserInterface } from '@thiememeulenhoff/types';
import { PlatformEndpointService } from './platform.endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(PlatformEndpointService);

  me(renew = false) {
    const params = {
      ...(renew ? { renew: 'true' } : {}),
    };

    return this.#http.get<UserInterface>(this.#endpoints.me(), { params }).pipe(
      tap(() => {
        if (renew) {
          this.#http.post(this.#endpoints.refreshEditionUser(), {}).subscribe();
        }
      }),
    );
  }

  activateLicenses(eans: Array<string>) {
    const endpoint = this.#endpoints.activateLicense();

    return this.#http
      .post<UserInterface>(endpoint, {
        eans,
      })
      .pipe(
        tap(() =>
          this.#http.post(this.#endpoints.refreshEditionUser(), {}).subscribe(),
        ),
      );
  }
}
